import { NESTED_DIALOG_Z } from "@/components/AdminPanel/Organization/components/manage-pane-primitives";
import {
  PaymentMethodDialog,
  type PaymentMethodDialogSession,
} from "@/components/billing/PaymentMethodDialog";
import { useCallback, useState } from "react";

/**
 * Card entry as a dialog over Settings, mounted once per layout beside the
 * manage-plan modal. Every "Add/Update payment method" action reaches it
 * through `useStartPaymentMethodSetup`.
 */
export function usePaymentMethodDialog() {
  const [session, setSession] = useState<PaymentMethodDialogSession | null>(
    null,
  );
  const [isOpen, setIsOpen] = useState(false);
  const [openCount, setOpenCount] = useState(0);

  // Both stable: the shell's `closeSettings` closes over the closer.
  const openPaymentMethodDialog = useCallback(
    (next: PaymentMethodDialogSession) => {
      setSession(next);
      setOpenCount((count) => count + 1);
      setIsOpen(true);
    },
    [],
  );
  const closePaymentMethodDialog = useCallback(() => setIsOpen(false), []);

  const paymentMethodDialog =
    openCount > 0 && session ? (
      <PaymentMethodDialog
        // Fresh SetupIntent, cleared Stripe fields and cleared errors per open.
        key={openCount}
        open={isOpen}
        session={session}
        zIndexClassName={NESTED_DIALOG_Z}
        onOpenChange={(next) => {
          if (!next) closePaymentMethodDialog();
        }}
      />
    ) : null;

  return {
    openPaymentMethodDialog,
    closePaymentMethodDialog,
    paymentMethodDialog,
  };
}
